import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useStatuses } from '../hooks/useStatuses';
import { useConfirmation } from '../../../common/hooks/useConfirmation';
import StatusModal from '../components/StatusModal';

const StatusesPage = () => {
  const { statuses, loading, error, addStatus, editStatus, removeStatus } = useStatuses();
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const { confirm } = useConfirmation();

  const openCreateModal = () => {
    setSelectedStatus(null);
    setModalVisible(true);
  };

  const openEditModal = (status) => {
    setSelectedStatus(status);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setSelectedStatus(null);
  };

  const handleSave = async (formData) => {
    if (selectedStatus) {
      await editStatus(selectedStatus.id, formData);
    } else {
      await addStatus(formData);
    }
  };

  const handleDelete = (status) => {
    confirm({
      message: `¿Estás seguro de que quieres eliminar el estado "${status.name}"?`,
      header: 'Confirmar Eliminación',
      accept: async () => {
        await removeStatus(status.id);
      }
    });
  };

  if (loading) {
    return (
      <div className="p-4">
        <Card className="shadow-2">
          <div className="text-center">
            <ProgressSpinner />
            <p>Cargando estados...</p>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="p-4">
      <Card title="Estados" className="shadow-2">
        {error && (
          <Message
            severity="error"
            text={`Error al cargar los estados: ${error}`}
            className="w-full mb-4"
          />
        )}

        <div className="mb-4">
          <Button
            label="Crear Estado"
            icon="pi pi-plus"
            className="p-button-primary"
            onClick={openCreateModal}
          />
        </div>

        <DataTable
          value={statuses}
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 25]}
          tableStyle={{ minWidth: '50rem' }}
          emptyMessage="No se encontraron estados"
        >
          <Column field="id" header="ID" sortable style={{ width: '15%' }} />
          <Column field="name" header="Nombre" sortable style={{ width: '25%' }} />
          <Column field="description" header="Descripción" sortable style={{ width: '40%' }} />
          <Column
            header="Acciones"
            body={(rowData) => (
              <div className="flex gap-2">
                <Button
                  icon="pi pi-pencil"
                  className="p-button-text p-button-rounded"
                  onClick={() => openEditModal(rowData)}
                  tooltip="Editar"
                />
                <Button
                  icon="pi pi-trash"
                  className="p-button-text p-button-rounded p-button-danger"
                  onClick={() => handleDelete(rowData)}
                  tooltip="Eliminar"
                />
              </div>
            )}
            style={{ width: '20%' }}
          />
        </DataTable>
      </Card>

      <StatusModal
        visible={modalVisible}
        onHide={closeModal}
        status={selectedStatus}
        onSave={handleSave}
      />
      <ConfirmDialog />
    </div>
  );
};

export default StatusesPage;